//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import apiSolicitudes from '@/api/promotores/usuarios/originacion.api'

export default {
    data() {
        return {
            per_page_options: [10, 20, 30, 40, 50, 100],
            columns: [
                { name: "nombre", label: "Nombre", field: "nombre", align: "left", classes: "bg-grey-2 ellipsis", style: "width: 350px", headerClasses: "bg-primary text-white", },
                { name: "importe", label: "Monto solicitado", field: "importe_solicitado", sortable: true, format: this.currency, },
                { name: "autorizado", label: "Monto autorizado", field: "ejercido.monto_autorizado_comite", sortable: true, format: this.currency, },
                { name: "plazo", label: "Plazo", field: "plazo", sortable: true, format: this.formatPlazo },
                { name: "email", label: "Correo electrónico", field: "email" },
                { name: "telefono", label: "Télefono", field: "telefono" },
                { name: "created_at", label: "Creación", field: "created_at", sortable: true, },
            ],
            solicitudes: [],
            loading: false

        }
    },
    mounted() {
        this.loadSolicitudes();
    },
    methods: {
        async loadSolicitudes() {
            try {
                this.loading = true;
                this.solicitudes = await apiSolicitudes.all(this.$route.params.promotor)
            } finally {
                this.loading = false

            }
            console.log(this.solicitudes)
        },
        formatPlazo(plazo) {
          return this.pluralize(plazo, ["año", "años"])
        },
    },
}
